// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3qrpg","box":"WorkspacesBox_box__3ISbd","node":"WorkspacesBox_node__9Skba"};